import { createState } from "@/global/store/zustand_store";
import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { Box, Stack, Typography } from "@mui/material";
import { BorderLinearProgress } from "@/shared/base/components/BorderLinearProgress/BorderLinearProgress";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import React from "react";
import { AnimatedTextPreloader } from "@/shared/common/preloader/AnimatedTextPreloader";

export const useModalState = createState({
  isOpen: false,
  onFinish: (a: any) => {},
});

export const useAutoSeatSelectionProgressModal = () => {
  const { onFinish, set, reset, ...modalState } = useModalState();
  const execute = (args: typeof modalState) => {
    return new Promise<any>((resolve) => {
      set({ ...args, onFinish: resolve });
    });
  };
  return { ...modalState, onFinish, set, reset, execute };
};

export function AutoSeatSelectionProgressModal() {
  const modalState = useAutoSeatSelectionProgressModal();
  const teamConfig = useTeamConfig();
  const customMessages = React.useMemo(
    () => teamConfig?.uiConfigs?.chooseSeatsPreloaderTexts,
    []
  );

  return (
    <>
      <NotificationModal
        isOpen={modalState.isOpen}
        hideTitleIcon
        hideCloseIcon={true}
        title="Automatic Seat Selection"
        description={
          <Box>
            <AnimatedTextPreloader
              messages={customMessages}
              renderProgressBar={() => {
                return <BorderLinearProgress variant="indeterminate" />;
              }}
            />
          </Box>
        }
        renderFooter={() => <></>}
      />
    </>
  );
}
